module.exports = __webpack_public_path__ + "static/loading-5d34c34c492540cce715371764fa6164.jpg";